import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Edit, Globe } from "lucide-react";

interface Vendor {
  id: string;
  name: string;
  domain: string | null;
  theme: string | null;
  status: string;
}

const VendorCMS = () => {
  const { data: vendors } = useQuery({
    queryKey: ['vendors-cms'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('vendors')
        .select('*');
      if (error) throw error;
      return data as Vendor[];
    }
  });

  return (
    <div className="space-y-4">
      <Card className="p-6">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Vendor Name</TableHead>
              <TableHead>Domain</TableHead>
              <TableHead>Theme</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {vendors?.map((vendor) => (
              <TableRow key={vendor.id}>
                <TableCell>{vendor.name}</TableCell>
                <TableCell>
                  <div className="flex items-center space-x-2">
                    <Globe className="h-4 w-4" />
                    <span>{vendor.domain || 'Not configured'}</span>
                  </div>
                </TableCell>
                <TableCell>{vendor.theme || 'Default'}</TableCell>
                <TableCell>{vendor.status}</TableCell>
                <TableCell>
                  <Button variant="outline" size="sm">
                    <Edit className="h-4 w-4" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
};

export default VendorCMS;